import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import profileImage from '../assets/profile.jpg';

export default function Hero() {
  return (
    <section className="relative flex min-h-screen items-center px-4 pb-16 pt-28 sm:pb-20 sm:pt-36" id="hero">
      <div className="site-container grid items-center gap-10 sm:gap-14 lg:grid-cols-[1.1fr_0.9fr]">
        <div className="max-w-3xl">
          <p className="section-eyebrow hero-enter">Flutter Developer</p>
          <h1 className="hero-enter hero-enter-delay-1 mt-5 text-4xl font-extrabold leading-[1.03] tracking-tight text-white sm:mt-6 sm:text-7xl">
            Muhammad Hassan <span className="gradient-text">Yousuf</span>
          </h1>
          <p className="hero-enter hero-enter-delay-2 mt-7 max-w-2xl text-xl font-semibold leading-relaxed text-slate-200 sm:text-2xl">
            Flutter developer building mobile and web applications with Dart, Firebase, Node.js, and MongoDB.
          </p>
          <p className="hero-enter hero-enter-delay-3 mt-5 max-w-xl text-base leading-8 text-slate-400 sm:text-lg">
            I create responsive applications with clean interfaces, Firebase integrations, real-time features, and a focus on dependable user experiences.
          </p>
          <div className="hero-enter hero-enter-delay-4 mt-9 flex flex-col gap-3 sm:flex-row">
            <a href="#projects" className="focus-ring inline-flex items-center justify-center rounded-full bg-gradient-to-r from-indigo-400 via-violet-400 to-cyan-300 px-6 py-3.5 text-sm font-extrabold text-slate-950 transition hover:-translate-y-0.5 hover:shadow-lg hover:shadow-indigo-500/20">View my work</a>
            <a href="#contact" className="focus-ring inline-flex items-center justify-center rounded-full border border-slate-700 px-6 py-3.5 text-sm font-bold text-slate-200 transition hover:border-slate-400 hover:bg-slate-900">Let's connect</a>
          </div>
          <div className="hero-enter hero-enter-delay-4 mt-8 flex items-center gap-5 text-slate-500">
            <span className="text-xs font-semibold uppercase tracking-[0.16em]">Find me on</span>
            <a href="https://www.github.com/hassan-yousuf" target="_blank" rel="noopener noreferrer" aria-label="GitHub profile" className="focus-ring transition hover:text-white"><FaGithub size={20} /></a>
            <a href="https://www.linkedin.com/in/hassan-sakaria" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn profile" className="focus-ring transition hover:text-cyan-300"><FaLinkedin size={20} /></a>
          </div>
        </div>

        <div className="hero-enter hero-enter-delay-3 relative mx-auto w-full max-w-sm lg:max-w-md">
          <div className="absolute -inset-5 rounded-[2rem] bg-gradient-to-br from-indigo-500/20 via-transparent to-cyan-400/10 blur-2xl" aria-hidden="true" />
          <div className="surface-card relative overflow-hidden p-3">
            <div className="aspect-[4/5] overflow-hidden rounded-[0.95rem] bg-slate-900">
              <img src={profileImage} alt="Muhammad Hassan Yousuf" width="851" height="1114" fetchPriority="high" decoding="async" className="h-full w-full object-cover" />
            </div>
            <div className="flex items-center justify-between gap-4 px-2 pb-1 pt-4">
              <div>
                <p className="text-sm font-bold text-white">Mobile Application Developer</p>
                <p className="mt-1 text-xs text-slate-500">Dart · Flutter · Firebase</p>
              </div>
              <span className="h-2.5 w-2.5 rounded-full bg-cyan-300 shadow-[0_0_16px_rgba(34,211,238,0.8)]" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
